import i18n from '@/lang'

export default [
  {
    name: 'caregiverSignup',
    path: '/signup/caregiver',
    component: () => import('@/pages/Caregiver/Signup'),
    meta: {
      title: '復健者綁定',
      isSupportMobile: true
    }
  },
  {
    path: '/caregiver/:id',
    component: () => import('@/layouts/Caregiver/index'),
    meta: {
      title: i18n.t('router.patient.text_1'),
      isSupportMobile: true
    },
    props: true,
    children: [
      {
        name: 'caregiverSummary',
        path: '',
        component: () => import('@/pages/Caregiver/Summary'),
        meta: {
          title: '運動記錄',
          isSupportMobile: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/caregiver.js